import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'membershealth-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: "Member's Health",
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8004840152,
  email: 'support@membershealth.ca',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/membershealth/index.js